import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const KEY = "rsell_ai_cookie_ack_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {}
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 220 }}
          data-testid="cookie-banner"
          style={{
            background: "#FFFFFF",
            border: "1px solid #E9ECEF",
            boxShadow: "0 12px 40px -8px rgba(15, 23, 42, 0.15)",
          }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 z-50 max-w-sm rounded-2xl p-4 sm:p-5"
        >
          <div className="flex items-start gap-3">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ background: "#FFF7ED" }}
            >
              <Cookie size={16} style={{ color: "#C2410C" }} />
            </div>
            <div className="flex-1 min-w-0">
              <div style={{ color: "#0F172A" }} className="text-sm font-semibold mb-1.5">
                Storage &amp; fraud prevention
              </div>
              <p style={{ color: "#475569" }} className="text-xs leading-relaxed">
                We use browser storage and light device fingerprinting to keep your session and prevent free-tier abuse — no tracking or ad cookies.{" "}
                <Link
                  to="/privacy"
                  style={{ color: "#047857" }}
                  className="font-semibold underline hover:no-underline"
                >
                  Read more
                </Link>.
              </p>
              <button
                type="button"
                data-testid="cookie-banner-accept"
                onClick={dismiss}
                style={{ background: "#0F172A", color: "#FFFFFF", minHeight: "40px" }}
                className="mt-3 w-full sm:w-auto px-5 py-2 rounded-lg text-xs font-semibold hover:opacity-90 transition-opacity"
              >
                Got it
              </button>
            </div>
            <button
              type="button"
              onClick={dismiss}
              aria-label="Dismiss"
              style={{ color: "#94A3B8" }}
              className="hover:opacity-70 transition-opacity flex-shrink-0"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
